import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/__authed/m/commissions")({
	component: Outlet,
});
